import {delay} from "p3";

export default class ScrollBar extends PIXI.Sprite {
    /**
     * @param {PIXI.Texture} texture
     * @param {Number} range
     */
    constructor(texture, range) {
        super(texture);

        this._scrollDownSound = null;
        this._scrollUpSound = null;

        this._startPos = null;
        this._range = range;
        this._dragging = false;
        this._targetY = null;
        this._mouseMoveSignal = null;
    }

    init(){
        this.interactive = true;
        this.buttonMode = true;

        this.on("mousedown", this._onMouseDown, this);
        this.on("touchstart", this._onMouseDown, this);
        //this.on("mouseup", this._onMouseUp, this);
        //this.on("touchend", this._onMouseUp, this);
        //this.on("mouseupoutside", this._onMouseUpOutside, this);
        this._mouseUpSignal = P3.input.signals.mouseUp.add(this._onMouseUp, this);
        this._mouseMoveSignal = P3.input.signals.mouseMove.add(this._onMouseMove, this);

        this._startPos = new PIXI.Container();
        this._startPos.position.set(this.x, this.y);
        this.parent.addChild(this._startPos);
        this._targetY = this.y;
    }

    destroy(){
        this.off("mousedown", this._onMouseDown, this);
        this.off("touchstart", this._onMouseDown, this);
        /*this.off("mouseup", this._onMouseUp, this);
        this.off("touchend", this._onMouseUp, this);
        this.off("mouseupoutside", this._onMouseUpOutside, this);*/

        this._mouseMoveSignal.detach();
        this._mouseUpSignal.detach();
        
        if(this._startPos.parent){
            this._startPos.parent.removeChild(this._startPos);
        }
    }

    update(){
        this.y += (this._targetY - this.y) * 0.7;
    }

    _onMouseDown(e){
        this._dragging = true;
        let pos = e.data.getLocalPosition(this._startPos);
        this._targetY = pos.y;
    }

    _onMouseUp(e) {
        this._dragging = false;
    }

    _onMouseUpOutside(e){
        this._dragging = false;
    }

    _playScrollingUpSound() {
        if (this._scrollUpSound && this._scrollUpSound.howl) {
            return;
        }

        this._scrollUpSound = P3.audio.playSound("sfx_btn_quest_scroll_up");
    }

    _playScrollingDownSound() {
        if (this._scrollDownSound && this._scrollDownSound.howl) {
            return;
        }

        this._scrollDownSound = P3.audio.playSound("sfx_btn_quest_scroll_down");
    }

    _onMouseMove(e){
        if(!this._dragging) {
            return;
        }

        let pos = e.data.getLocalPosition(this._startPos);

        this._targetY = Math.max(this._startPos.y, Math.min(this._startPos.y + this._range, pos.y));

        this.playSound(this._targetY - this._oldY)

        this._oldY = pos.y;
    }

    startDrag() {
        this._dragging = true;
    }

    stopDrag() {
        this._dragging = false;
    }

    playSound(value) {
        if (value < 0) {
            this._playScrollingUpSound();
        } else if (value > 0) {
            this._playScrollingDownSound();
        } 
    }

    get value(){
        return Math.max(0, Math.min(1, (this.y - this._startPos.y) / this._range));//(this._range - this._startPos.y)));
    }

    set value(p) {
        this.y = this._startPos.y + (this._range * p);
    }

    get dragging() {
        return this._dragging;
    }
}

